import styled from '@emotion/styled';
import { Button } from '@core/components/Button/Button';
import { Z_GATE } from '@embed/components/VideoPlayer/Player3/constants/zIndexes';
import { UnlockVideo } from '@player/assets/UnlockVideo';
const GATE_OVERLAY_FORM_SPACING = '22px';
export const GateWrapper = styled.div `
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  color: black;
  position: absolute;
  z-index: ${Z_GATE};
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 18%;
`;
export const PosterOverlay = styled.div `
  background: rgba(56, 56, 56, 0.7);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;
export const ErrorMessage = styled.div `
  color: #fff;
  font-feature-settings:
    'clig' off,
    'liga' off;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 0;
  min-height: 30px;
`;
export const AccessCodeField = styled.input `
  color: ${({ error }) => (error ? 'red' : 'inherit')};
  padding: 7px 10px;
  &::placeholder {
    color: var(--gray5, #bdbdbd);
    font-feature-settings:
      'clig' off,
      'liga' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  width: 100%;

  border-radius: 4px;
  border: 1px solid ${({ error }) => (error ? 'var(--red)' : '#d9d9d9')};
  background: #fff;
`;
const posterStyles = `
  filter: blur(15px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
  pointer-events: none;`;
export const GatePosterImg = styled.img `
  ${posterStyles}
`;
export const GatePosterVideo = styled.video `
  ${posterStyles}
`;
export const GateForm = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const GateFormTitle = styled.div `
  color: #fff;
  text-align: center;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: ${GATE_OVERLAY_FORM_SPACING};
`;
export const GateFormButton = styled(Button) `
  margin-bottom: ${GATE_OVERLAY_FORM_SPACING};
  background: var(--primary, #0f6bff);
`;
export const GateLockIcon = styled(UnlockVideo) `
  margin-bottom: ${GATE_OVERLAY_FORM_SPACING};
`;
